import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useEventPanelUnits } from './units/use-event-panel-units';

export const useAllowAddingTowVehicles = () => {
    const {
        eventsAllowAddingTowVehicle,
        addTowVehiclesAssignedEvents,
        addTowVehiclesUnassignedEvents,
    } = useEnabledFeatures();
    const eventPanelUnits = useEventPanelUnits();
    const eventHasAssignedUnits = eventPanelUnits.length > 0;
    const allowAddingTowVehicles = eventHasAssignedUnits
        ? addTowVehiclesAssignedEvents
        : addTowVehiclesUnassignedEvents;

    return eventsAllowAddingTowVehicle && allowAddingTowVehicles;
};
